import { WRM } from '@confluence-classic/confluence-wrm';

// These dependencies will enable inline comments and highlight menu to work
const WRM_RESOURCES = [
	'wr!com.atlassian.confluence.plugins.confluence-jira-content:confluence-jira-content-loader',
	'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources',
	'wr!confluence.web.resources:view-content',
	// CONFSIM-1578 This is required in order for Page Properties Report Macro with checkboxes to work
	'wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-styles',
];

export const loadContentRendererWRM = () => WRM.require(WRM_RESOURCES);
